import * as ss from 'superstruct';
import { InputStreamSourceConfig } from './types';
import { Id } from '../../types';
import { IntegrationConnectionRef } from '../../connected-accounts';

export const ConversionInputStreamResource = ss.type({
  id: Id,
  description: ss.optional(ss.nullable(ss.string())),
  enabled: ss.boolean(),
  source: InputStreamSourceConfig,
  /** For sources that read through one; see `inputStreamConnectionType`. */
  integrationConnection: ss.optional(ss.nullable(IntegrationConnectionRef)),
  lastIngestedEventTimeMs: ss.optional(ss.nullable(ss.number())),
  startTimeMs: ss.number(),
  createdAt: ss.optional(ss.nullable(ss.date())),
  updatedAt: ss.optional(ss.nullable(ss.date())),
});

export type ConversionInputStreamResource = ss.Infer<
  typeof ConversionInputStreamResource
>;
